module.exports = __webpack_public_path__ + "img/television_mount.fb62d73e.jpg";